export default {
  // 能否下拉刷新
  canPullRefresh: true
};
